// 행사 연도 단일 진실 공급원(SSOT)
// - basename, dev 진입 경로 정규식, main_list 조회용 year 등에 모두 사용
export const EVENT_YEAR = 2026;
export const BASENAME = `/${EVENT_YEAR}`;
export const DEV_ENTRY_PATH_REGEX = new RegExp(`^/${EVENT_YEAR}/?$`);

// 행사 종료 시각의 임시 기준 — 2026년 10월 1일 00시 00분 (KST)
// 실제 기준은 백오피스(행사 연도 > 행사 종료 시각 = ee_finish_at)에 설정된 값이고,
// 이 상수는 그 값이 도착하기 전 / 조회에 실패했을 때만 쓰인다.
// 오프셋(+09:00)을 명시해, 접속자의 기기 시간대와 무관하게 모두 같은 순간에 전환된다.
export const FINISH_AT = new Date(`${EVENT_YEAR}-10-01T00:00:00+09:00`);
